import { createContext } from '@chakra-ui/react-utils';

import type { TrProps } from '../components/Tr';

export type TrContextValue = Pick<TrProps, 'index' | 'isInteractive'>;

const [TrProvider, useTrContext] = createContext<TrContextValue>({
  name: 'TrContext',
  errorMessage:
    'useTrContext: `context` is undefined. Seems you used a Tr sub-component that required context outside of a Tr component.',
  strict: false,
});

export { TrProvider, useTrContext };
